import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { I18nService } from '@app/i18n/services';
import { FeedbackData, FeedbackService, FeedbackStyle, FeedbackTitle } from '@services/feedback';
import { ProgressIndicatorService } from '@services/progress';
import { UsersService } from '../../../../../../services/users';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';

import { ISendResetPasswordEmailDialogData } from './users-send-reset-password-email.models';

@Component({
	selector: 'app-users-send-reset-password-email',
	templateUrl: './users-send-reset-password-email.dialog.html'
})
export class UsersSendResetPasswordEmailDialogComponent extends OnDestroyMixin {
	constructor(
		private i18nService: I18nService,
		private feedbackService: FeedbackService,
		private usersService: UsersService,
		private progressIndicatorService: ProgressIndicatorService,
		@Inject(MAT_DIALOG_DATA) public dialogData: ISendResetPasswordEmailDialogData,
		private dialogRef: MatDialogRef<UsersSendResetPasswordEmailDialogComponent>
	) {
		super();
	}

	public onFormSubmit(): void {
		const data: FeedbackData = {
			title: FeedbackTitle.warning,
			message: this.i18nService.get(
				'This will send the user a request to reset their password. Are you sure you want to continue?',
				'app.prompt.users.send-password-reset-email.confirm-message'
			),
			style: FeedbackStyle.error,
			callback: (confirmed: boolean) => {
				if (confirmed) {
					this.sendResetPasswordEmail();
				} else {
					this.dialogRef.close();
				}
			}
		};

		this.feedbackService.confirm(data);
	}

	private sendResetPasswordEmail(): void {
		this.progressIndicatorService.spinner(true);

		this.usersService
			.sendResetPasswordEmail(this.dialogData.user.email)
			.subscribe(
				() => {
					this.feedbackService.notification({
						msg: this.i18nService.get(
							'Successfully requested a password reset.',
							'app.descriptor.users.reset-password-email-sent'
						),
						config: { duration: 4000 }
					});
					this.progressIndicatorService.spinner(false);
					this.dialogRef.close();
				},
				(error: any) => {
					this.feedbackService.apiError(error);
					this.progressIndicatorService.spinner(false);
				}
			);
	}
}
